import React from 'react';
import Icon from '../Icon';
import CountUp from './CountUp';

export function KpiGrid({ children, className = '' }) {
  return <section className={`kpi-grid ${className}`}>{children}</section>;
}

function KpiCard({
  label, value, icon, iconBg, iconColor, sub, countUp = false,
  delay = 0, className = '',
}) {
  return (
    <div className={`kpi-card anim-fade ${delay ? `anim-d${delay}` : ''} ${className}`}>
      <div className="kpi-top">
        <span className="kpi-label">{label}</span>
        {icon && (
          <span className="kpi-icon" style={{ background: iconBg || 'rgba(139,92,246,0.10)', color: iconColor || '#a78bfa' }}>
            <Icon name={icon} size={17} />
          </span>
        )}
      </div>
      <div className="kpi-value">
        {countUp && typeof value === 'number' ? <CountUp value={value} /> : value}
      </div>
      {sub && <div className="kpi-sub">{sub}</div>}
    </div>
  );
}

export default KpiCard;
